import Stack from "@mui/joy/Stack";
import CloseButtonSmall from "../change-status-button/CloseButtonSmall";
import { theme } from "../../../styles/theme";
import React from "react";

export default function TransparentHeader({
  hideCloseButton,
}: {
  hideCloseButton?: boolean;
}) {
  return (
    <Stack
      direction={"column"}
      sx={{
        width: "100%",
        position: "fixed",
        px: 0,
        height: "var(--StickyHeader-height)",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent="end"
        sx={{
          width: "100%",
          flex: 1,
          px: "8px",
        }}
      >
        {!hideCloseButton && (
          <CloseButtonSmall iconColor={theme.vars.palette.Content.Negative} />
        )}
      </Stack>
    </Stack>
  );
}
